// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__S1oHz","load8":"Loader_load8__X4nGo"};